import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V192H0V464zM320 268C320 261.4 325.4 256 332 256H372C378.6 256 384 261.4 384 268V308C384 314.6 378.6 320 372 320H332C325.4 320 320 314.6 320 308V268zM320 396C320 389.4 325.4 384 332 384H372C378.6 384 384 389.4 384 396V436C384 442.6 378.6 448 372 448H332C325.4 448 320 442.6 320 436V396zM192 268C192 261.4 197.4 256 204 256H244C250.6 256 256 261.4 256 268V308C256 314.6 250.6 320 244 320H204C197.4 320 192 314.6 192 308V268zM192 396C192 389.4 197.4 384 204 384H244C250.6 384 256 389.4 256 396V436C256 442.6 250.6 448 244 448H204C197.4 448 192 442.6 192 436V396zM64 268C64 261.4 69.4 256 76 256H116C122.6 256 128 261.4 128 268V308C128 314.6 122.6 320 116 320H76C69.4 320 64 314.6 64 308V268zM64 396C64 389.4 69.4 384 76 384H116C122.6 384 128 389.4 128 396V436C128 442.6 122.6 448 116 448H76C69.4 448 64 442.6 64 436V396zM400 64H352V16C352 7.2 344.8 0 336 0H304C295.2 0 288 7.2 288 16V64H160V16C160 7.2 152.8 0 144 0H112C103.2 0 96 7.2 96 16V64H48C21.5 64 0 85.5 0 112V160H448V112C448 85.5 426.5 64 400 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-alt.js
// module id = k6Qi
// module chunks = 144